export class Audit_Log {

  log_Id = 0;
  entity = '';
  actionType = '';
  description = '';
  oldDataJSON = '';
  user_Id = '';
  entity_Id = 0;

  actionTypes = ActionType;
  auditTypes = AuditType;

}

enum ActionType {
  INSERT = "INSERT",
  UPDATE = "UPDATE",
  DELETE = "DELETE"
}

enum AuditType {
  Companies = "Companies",
  Locations = "Locations",
  CustomerTypes = "CustomerTypes",
  Material = "Material",
  Size = "Size",
  ProductType = "ProductType",
  ValveType = "ValveType",
  Region = "Region",
  Managed_Cylinder_Info = "Managed Cylinder Info"
}
